import React, { useRef } from 'react';
import { Textarea } from './ui/textarea';
import { Button } from './ui/button';
import { Bold, Italic, List } from 'lucide-react';

export const RichTextarea = ({ value, onChange, placeholder, rows = 4, ...props }) => {
  const textareaRef = useRef(null);

  const insertFormatting = (before, after = before) => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = value.substring(start, end);
    
    let newText;
    let newCursorPos;

    if (selectedText) {
      // Wrap selected text
      newText = value.substring(0, start) + before + selectedText + after + value.substring(end);
      newCursorPos = end + before.length + after.length;
    } else {
      // Insert at cursor
      newText = value.substring(0, start) + before + after + value.substring(end);
      newCursorPos = start + before.length;
    }

    onChange({ target: { value: newText } });
    
    // Restore focus and cursor position
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(newCursorPos, newCursorPos);
    }, 0);
  };

  const handleBold = () => insertFormatting('**');
  const handleItalic = () => insertFormatting('*');
  const handleList = () => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const lineStart = value.lastIndexOf('\n', start - 1) + 1;
    const beforeLine = value.substring(0, lineStart);
    const afterCursor = value.substring(start);
    const currentLine = value.substring(lineStart, start);

    const newText = beforeLine + '- ' + currentLine + afterCursor;
    onChange({ target: { value: newText } });

    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(start + 2, start + 2);
    }, 0);
  };

  return (
    <div className="space-y-2">
      <div className="flex gap-1 p-1 bg-muted/20 rounded-lg w-fit">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={handleBold}
          className="h-8 w-8 p-0"
          title="Bold (**text**)"
        >
          <Bold className="h-4 w-4" />
        </Button>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={handleItalic}
          className="h-8 w-8 p-0"
          title="Italic (*text*)"
        >
          <Italic className="h-4 w-4" />
        </Button>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={handleList}
          className="h-8 w-8 p-0"
          title="List item (- item)"
        >
          <List className="h-4 w-4" />
        </Button>
      </div>
      <Textarea
        ref={textareaRef}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        {...props}
      />
      <p className="text-xs text-foreground/40">
        **bold** • *italic* • - list item
      </p>
    </div>
  );
};
